import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ToastService } from "@app/services";
import { StateStatus } from "@app/state/model";
import {
  selectChecklistTemplatesStatus,
  selectChecklistTemplatesTotal,
} from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take, tap } from "rxjs";

export const checklistTemplateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const toast = inject(ToastService);
  return combineLatest([
    store.select(selectChecklistTemplatesStatus),
    store.select(selectChecklistTemplatesTotal),
  ]).pipe(
    tap(([status, total]) => {
      if (total > 0) return;
      switch (status) {
        case StateStatus.Pending:
          toast.show("Checklist Templates pending to load...");
          break;
        case StateStatus.Loading:
          toast.show("Checklist Templates loading...");
          break;
        case StateStatus.Error:
          toast.show("Checklist Templates failed to load...");
          break;
      }
    }),
    filter(
      ([status, total]) =>
        total > 0 ||
        status === StateStatus.Success ||
        status === StateStatus.Error
    ),
    map(([status, total]) => total > 0 || status === StateStatus.Success),
    take(1)
  );
};
